import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { merge, $ } from "glamor";
//import Color from 'color';
import theme from "styles/theme";
import Globalize from "globalize";
import { format as t } from "lib/globalize-util";
import classNames from "classnames";
import IconButton from "material-ui/IconButton";
import app from "lib/app";
import Profile from "./profile";
import { Section } from "./section";
import MenuItem from "./menu-item";
import Footer from "./footer";
import Sites from "./live-events";

import MoneyIcon from "material-ui/svg-icons/editor/attach-money";
import ReportingIcon from "components/icons/reporting";
import OrdersIcon from "components/icons/orders";
import CampaignsIcon from "components/icons/campaigns";
import ContactsIcon from "components/icons/contacts";
import ListsIcon from "components/icons/list";
import { LinesheetsIcon } from "components/icons/linesheets";
import DownloadIcon from "components/icons/download";

import Close from "material-ui/svg-icons/navigation/close";
import SettingsIcon from "material-ui/svg-icons/action/settings";
import MediaIcon from "material-ui/svg-icons/image/photo-library";
import DashboardIcon from "material-ui/svg-icons/action/dashboard";
import HomeIcon from "material-ui/svg-icons/action/home";
import MenuIcon from "material-ui/svg-icons/navigation/menu";
import { WhiteBoardIcon } from "components/icons/whiteboards";
import { HandShake } from "components/icons/handshake";
import ReactTouchEvents from "react-touch-events";
import AutoLockScrolling from "material-ui/internal/AutoLockScrolling";
import { HangTag } from "components/icons/hang-tag";
import { Assortments } from "components/icons/assortments";

import pathToRegexp from "path-to-regexp";

import { APP_MENU_STATE_ICON, APP_MENU_STATE_HOVER, APP_MENU_STATE_PINNED } from "constants/menu";
import Timeout from "components/helpers/hoc/timeout";
import { canAccessB2BPOSIntegration } from "components/helpers/b2b/can-access-pos-integration";
import { DATATEST } from "constants/integration";
import { STANDARD } from "constants/brand-subscriptions";
import { canAccessAssortments } from "helpers/access";
import { DRIVE_LINK } from "containers/folders/utils/constants";
import { LANDING_PAGE_DELIMITER } from "containers/sites-manager/hooks";
import { WindowAnalytics } from "helpers/window-analytics";
import { hasPaymentProcessorByName as _hasPaymentProcessorByName } from "helpers/access-control";

import { SearchSettings } from "constants/types";
import { hasActivePaymentAccount } from "components/payments/helpers";
import { gtm } from "helpers/gtm";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                backgroundColor: "white",
                position: "fixed",
                zIndex: 1002,
            },
            $(" nav", {
                backgroundColor: theme.palette.darkestGrey,
                position: "fixed",
                top: "0px",
                height: "100%",
                width: `${theme.nav.iconWidth}px`,
                transition: "all .15s ease-in-out",
                zIndex: 1001,
                left: "0px",
                display: "flex",
                flexDirection: "column",
            }),
            $(" .impersonated", {
                backgroundColor: "#FACE20",
            }),
            $(" .menuButton", {
                height: "60px",
                width: "48px",
                position: "fixed",
                top: "0px",
                left: "0px",
                padding: "8px 0 0 0",
                zIndex: 1002,
                overflow: "hidden",
                transition: "left .15s ease-in-out",
            }),
            $(
                ".isOpen",
                merge(
                    $(" nav", {
                        width: `${theme.nav.iconAndTextWidth}px`,
                    })
                )
            ),
            $(
                ".isMenuPinned &",
                merge(
                    $(" nav", {
                        width: `${theme.nav.iconAndTextWidth}px`,
                    })
                )
            ),
            $(
                ".isMobile &",
                merge(
                    $(" nav", {
                        left: `-${theme.nav.iconAndTextWidth}px`,
                        width: `${theme.nav.iconAndTextWidth}px`,
                        overflowY: "auto",
                    }),
                    $(".isOpen nav", {
                        left: "0px",
                    }),
                    $(".isOpen .menuButton", {
                        left: `${theme.nav.iconAndTextWidth - 48}px`,
                    }),
                    $(".isOpen .menuIcon", {
                        fill: "white !important",
                    }),
                    $(" .backDrop", {
                        position: "fixed",
                        left: "-100vw",
                        top: "0px",
                        width: "100vw",
                        height: "100%",
                        transition: "left .15s ease-in-out",
                        backgroundColor: "rgba(0,0,0,.2)",
                        zIndex: 1001,
                    }),
                    $(".isOpen .backDrop", {
                        left: "0px",
                    })
                )
            )
        );
    }
    return styles;
};

/** @augments {PureComponent<any, any>} */
class SiteNav extends PureComponent {
    static propTypes = {
        viewport: PropTypes.string.isRequired,
        onUpdateNavState: PropTypes.func.isRequired,
        menuState: PropTypes.string.isRequired,
        location: PropTypes.object.isRequired,
        me: PropTypes.object.isRequired,
        flags: PropTypes.object.isRequired,
        scope: PropTypes.object.isRequired,
        requestsCount: PropTypes.number,
        cancelledStylesCount: PropTypes.number,
        lsidIdentity: PropTypes.any,
        // cancelledOrdersCount: PropTypes.number,
    };

    constructor(props) {
        super(props);
        this.state = {};

        this.handleShowMenu = this.handleMenuOpen.bind(this, true);
        this.handleHideMenu = this.handleMenuOpen.bind(this, false);
        this.handleToggleMenu = this.handleMenuOpen.bind(this, null);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleCloseMenu = this.handleCloseMenu.bind(this);
        this.handleSwipe = this.handleSwipe.bind(this);
        this.handleFindNewAccountsMenuClick = this.handleFindNewAccountsMenuClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.viewport !== this.props.viewport) {
            this.setState({ isOpen: false });
        }
    }

    handleCloseMenu(e) {
        const { onUpdateNavState, menuState, disabled } = this.props;

        if (disabled) {
            app.legacy?.sendMessage({
                payload: { action: "leaving-working-order" },
            });
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        if (menuState === APP_MENU_STATE_HOVER) {
            onUpdateNavState(APP_MENU_STATE_ICON);
        }
    }

    handleSwipe(direction) {
        if (direction === "left") {
            this.handleCloseMenu();
        }
    }

    handleMenuOpen(open, e) {
        this.props.clearTimeouts();
        let { menuState } = this.props;
        const { onUpdateNavState, viewport } = this.props;

        if (e && e.stopPropagation) {
            e.stopPropagation();
        }

        if (open === null) {
            if (viewport === "mobile" || viewport === "phablet") {
                menuState = menuState === APP_MENU_STATE_HOVER ? APP_MENU_STATE_ICON : APP_MENU_STATE_HOVER;
            } else {
                menuState = menuState === APP_MENU_STATE_PINNED ? APP_MENU_STATE_ICON : APP_MENU_STATE_PINNED;
            }
        } else {
            if (menuState !== APP_MENU_STATE_PINNED) {
                menuState = open ? APP_MENU_STATE_HOVER : APP_MENU_STATE_ICON;
            }
        }

        if (menuState === APP_MENU_STATE_PINNED) {
            onUpdateNavState(menuState);
        } else {
            this.props.setTimeout(() => {
                if (menuState !== this.props.menuState) {
                    onUpdateNavState(menuState);
                }
            }, 350);
        }
    }

    handleLogout(e) {
        e.preventDefault();
        localStorage.removeItem(SearchSettings.SearchType);
        this.props.me.logout();
    }

    createBrandLink(link) {
        const { scope } = this.props;
        if (scope.brand) {
            return `/brand/${scope.brand._id}${link}`;
        }
        return link;
    }

    getLinesheetLink() {
        const { scope } = this.props;
        const catalogLinksToPage = scope.brand && scope.brand.getPreference("catalogs_links_to_page");
        if (catalogLinksToPage) {
            if (catalogLinksToPage.includes("site") && catalogLinksToPage.includes("page")) {
                const [_siteKey, _siteId, _pageKey, pageId, _slugKey, siteSlug] =
                    catalogLinksToPage.split(LANDING_PAGE_DELIMITER);
                return this.createBrandLink(`/site/${siteSlug}/page/${pageId}`);
            } else {
                return this.createBrandLink(`/page/${catalogLinksToPage}`);
            }
        } else {
            return this.createBrandLink("/linesheets");
        }
    }

    getOrganizationSettings = (name) => {
        const { me, flags } = this.props;
        const canAccessSiteSettings = this.canAccessSiteSettings();

        let organizationSettingsURL = canAccessSiteSettings ? this.createBrandLink("/sites") : "/the-wall/settings";
        let organizationSettingsMatchesURL = "/the-wall/settings";

        const retailersCount = me?.retailers?.length || 0;
        const retailerId = me?.retailers?.length ? me.retailers[0]._id : null;

        if (flags.merchantOrgNewProfileSettingsPageNu70852 && !canAccessSiteSettings && retailersCount) {
            organizationSettingsURL =
                retailersCount === 1 ? `/settings/organizations/${retailerId}/${name}` : "/settings/organizations";
            organizationSettingsMatchesURL = organizationSettingsURL;
        }

        return {
            organizationSettingsURL,
            organizationSettingsMatchesURL,
        };
    };

    hasAccessToOrders() {
        const { scope } = this.props;
        if (scope.brand && scope.brand._id && !scope.brand.hasPreference("no_orders")) {
            return true;
        }
        return false;
    }

    restrictByAccountType(type) {
        const { me } = this.props;
        if (me.account_type === "nuorder") {
            return true;
        }
        return type === this.props.me.account_type;
    }

    restrictByModule(module, requiredActiveBrand) {
        const { me, scope } = this.props;
        let hasPermission = false;

        if (!scope.brand || !scope.brand._id) {
            if (requiredActiveBrand) {
                return false;
            }
            return me.available_modules.includes(module);
        } else if (scope.brand && scope.brand.available_modules) {
            hasPermission = scope.brand.available_modules.indexOf(module) !== -1;
        }

        if (!hasPermission && ["admin", "reporting"].includes(module)) {
            return false;
        }
        return hasPermission || me.available_modules.includes(module);
    }

    restrictByDevice(device) {
        return window.navigator.userAgent.match(new RegExp(device, "i"));
    }

    canBeRedirectedToDrive = () => {
        const { scope } = this.props;
        if (scope.brand && scope.brand.hasModuleEnabled("drive")) {
            return true;
        }

        return false;
    };

    canAccessSiteSettings = () => {
        const { me, scope } = this.props;
        let valid = false;

        if (
            me.account_type === "buyer" &&
            me.merchant_connections &&
            me.merchant_connections.find((mc) => mc.capabilities && mc.capabilities.includes("dts"))
        ) {
            valid = true;
        } else if (me.account_type === "brand") {
            valid = true;
        } else if (me.account_type === "nuorder") {
            valid = true;
        }

        return valid;
    };

    hasPaymentProcessorByName = (gateway_name) => {
        const { me, scope } = this.props;
        const hasPaymentAccounts = _hasPaymentProcessorByName(gateway_name, scope);
        return (
            me.account_type === "brand" &&
            !me.actual_user &&
            me.hasPermission("can_access_payments_management") &&
            hasPaymentAccounts
        );
    };

    hasLightspeedPaymentsProcessor = () => {
        return this.hasPaymentProcessorByName("Lightspeed Payments");
    };

    handleManageCreditCardsMenuClick = () => {
        WindowAnalytics.track("Manage Payment Methods menu clicked", {});
    };

    handleFindNewAccountsMenuClick = () => {
        gtm.emit(
            gtm.events.marketPlace({
                event: "find-new-accounts-link-clicked",
                me: this.props.me,
                scope: this.props.scope,
            })
        );
    };

    render() {
        const { viewport, viewportHeight, touchDevice, menuState, me, flags, location, scope, lsidIdentity } =
            this.props;
        const { requestsCount, cancelledStylesCount, disabled } = this.props;
        const isMobile = viewport === "mobile" || viewport === "phablet";
        const isOpen = menuState === APP_MENU_STATE_HOVER;
        const isPinned = menuState === APP_MENU_STATE_PINNED;
        const toMarketplace = flags.displayLinkToNewMarketplace ? "/site/nuordermarketplace" : "/browse/brands";
        const smartOrdersQuantity = this.props.smartOrders?.data?.meta?.total_count;

        if (!me.isSignedIn()) {
            return null;
        }
        const catalogUrl = this.getLinesheetLink();
        const homeUrl = scope.brand && scope.brand._id ? this.createBrandLink("") : "/profile";

        const viewRequests = me.hasPermission("can_manage_connection_requests");
        const cancelledStyles =
            scope.brand && scope.brand.hasPreference("cancelled_styles") && me.hasPermission("manage_cancelled_styles");
        const canAccessSiteSettings = this.canAccessSiteSettings();
        const canAccessPOSIntegration =
            flags.merchantEnablementNoCustomerListNu42582 && canAccessB2BPOSIntegration(me, lsidIdentity);
        const canAccessMerchantManagement = flags.enableMerchantOrganizationFlowNu58916 && me.hasMerchantOrganization();
        const canAccessToReplenishementRecommendation =
            flags.smartOrdersPage &&
            (me.account_type === "brand" || me.account_type === "nuorder") &&
            scope.brand &&
            scope.brand.getPreference("insight_reports") &&
            me.hasPermission("manage_order_recommendations") &&
            this.props.smartOrders?.data?.meta?.connected_account_ids_count > 0;
        const canAccessLiveEvents = flags.showLiveEvents && me.account_type === "buyer";

        const impersonationStyle = {};
        if (me.actual_user) {
            impersonationStyle.backgroundColor = "#993333";
        }
        const paymentsMatches = [
            pathToRegexp(this.createBrandLink("/lightspeed-reports")),
            pathToRegexp(this.createBrandLink("/admin/brand/vp/paymenthistory")),
        ];
        if (flags.paymentsInvoicesMenuItemNu63696) {
            paymentsMatches.push(pathToRegexp(this.createBrandLink("/invoices")));
        }

        return (
            <div className={classNames({ isOpen: isOpen && !disabled })} {...getStyles()}>
                {isMobile && (
                    <div className="menuButton">
                        <IconButton onClick={this.handleToggleMenu}>
                            {isOpen ? <Close className="menuIcon" /> : <MenuIcon className="menuIcon" />}
                        </IconButton>
                    </div>
                )}
                {isMobile && <div className="backDrop" onClick={this.handleToggleMenu} />}

                {isMobile && <AutoLockScrolling lock={isOpen} />}

                <ReactTouchEvents onSwipe={this.handleSwipe}>
                    <nav
                        role="navigation"
                        key="navigation"
                        onMouseEnter={this.handleShowMenu}
                        onMouseLeave={this.handleHideMenu}
                        onClick={this.handleCloseMenu}
                        data-test={DATATEST.NAV.SITE_NAV}
                        style={impersonationStyle}
                    >
                        {me.account_type === "buyer" && (
                            <MenuItem
                                Icon={DashboardIcon}
                                primary={true}
                                label={Globalize.formatMessage("Dashboard")}
                                to="/dashboard"
                                viewport={viewport}
                                dataTest={DATATEST.NAV.DASHBOARD}
                            />
                        )}
                        <MenuItem
                            Icon={HomeIcon}
                            {...(me.account_type !== "buyer" && { primary: true })}
                            label={Globalize.formatMessage("Home")}
                            to={homeUrl}
                            location={location}
                            matches={pathToRegexp("/brand/:brand")}
                            hasAccess={this.restrictByModule("wholesale", true)}
                            viewport={viewport}
                            dataTest={DATATEST.NAV.HOME}
                        />

                        <Section expand={true} viewportHeight={viewportHeight} viewport={viewport}>
                            {me.canViewGallery() && this.restrictByModule("wholesale", true) && (
                                <MenuItem
                                    Icon={HangTag}
                                    label={Globalize.formatMessage("Products")}
                                    to={this.createBrandLink("/gallery")}
                                    location={location}
                                    matches={pathToRegexp("/brand/:brand/gallery")}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.PRODUCTS}
                                />
                            )}
                            {this.restrictByModule("wholesale", true) && (
                                <MenuItem
                                    Icon={LinesheetsIcon}
                                    label={
                                        scope.brand && scope.brand.hasPreference("linesheets_are_catalogs")
                                            ? Globalize.formatMessage("Catalogs")
                                            : Globalize.formatMessage("Linesheets")
                                    }
                                    to={catalogUrl}
                                    location={location}
                                    matches={pathToRegexp("/brand/:brand/linesheet*")}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.LINESHEETS}
                                >
                                    {me.hasPermission("create_linesheet") && (
                                        <MenuItem
                                            label={Globalize.formatMessage("Create Linesheet", {
                                                Linesheet:
                                                    scope.brand && scope.brand.hasPreference("linesheets_are_catalogs")
                                                        ? Globalize.formatMessage("Catalog")
                                                        : Globalize.formatMessage("Linesheet"),
                                            })}
                                            to={this.createBrandLink("/linesheets/create")}
                                            location={location}
                                            viewport={viewport}
                                            dataTest={DATATEST.NAV.CREATE_LINESHEET}
                                        />
                                    )}
                                </MenuItem>
                            )}
                            {this.restrictByModule("wholesale", true) && (
                                <MenuItem
                                    Icon={ListsIcon}
                                    label={Globalize.formatMessage("Custom Lists")}
                                    to={this.createBrandLink("/lists")}
                                    hasAccess={this.restrictByModule("wholesale", true)}
                                    location={location}
                                    matches={pathToRegexp("/brand/:brand/list*")}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.CUSTOM_LISTS}
                                />
                            )}
                            {this.restrictByModule("wholesale", true) && me.hasPermission("can_create_whiteboards") && (
                                <MenuItem
                                    Icon={WhiteBoardIcon}
                                    label={Globalize.formatMessage("Whiteboards")}
                                    to={this.canBeRedirectedToDrive() ? "/drive" : this.createBrandLink("/whiteboards")}
                                    location={location}
                                    matches={pathToRegexp(
                                        this.canBeRedirectedToDrive() ? "/drive" : "/brand/:brand/whiteboards"
                                    )}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.WHITEBOARDS}
                                />
                            )}
                            {canAccessAssortments(me, scope) && (
                                <MenuItem
                                    Icon={Assortments}
                                    label={Globalize.formatMessage("Assortments")}
                                    to={DRIVE_LINK}
                                    location={location}
                                    matches={pathToRegexp(DRIVE_LINK)}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.ASSORTMENTS}
                                />
                            )}
                            {this.restrictByModule("wholesale", true) && !me.isGuestBuyer() && (
                                <MenuItem
                                    Icon={ContactsIcon}
                                    label={Globalize.formatMessage("Contacts")}
                                    to={this.createBrandLink("/contacts")}
                                    location={location}
                                    matches={[
                                        pathToRegexp("/brand/:brand/contacts"),
                                        pathToRegexp("/brand/:brand/connection-requests"),
                                    ]}
                                    viewport={viewport}
                                    addNewIndicator={viewRequests && !!requestsCount}
                                    dataTest={DATATEST.NAV.CONTACTS}
                                >
                                    {me.account_type !== "buyer" &&
                                        this.hasAccessBySubscription(STANDARD) &&
                                        viewRequests && (
                                            <MenuItem
                                                label={Globalize.formatMessage("Connection requests")}
                                                to={this.createBrandLink("/connection-requests")}
                                                viewport={viewport}
                                                addNewBadge={!!requestsCount}
                                                badge={requestsCount}
                                                dataTest={DATATEST.NAV.CONNECTION_REQUESTS}
                                            />
                                        )}
                                </MenuItem>
                            )}
                            {this.restrictByModule("wholesale", true) &&
                                this.hasAccessToOrders() &&
                                this.hasAccessBySubscription(STANDARD) &&
                                !me.isGuestBuyer() && (
                                    <MenuItem
                                        Icon={OrdersIcon}
                                        label={t("Orders")}
                                        to={this.createBrandLink("/orders")}
                                        location={location}
                                        matches={pathToRegexp("/brand/:brand/order*")}
                                        viewport={viewport}
                                        addNewIndicator={
                                            (cancelledStyles && !!cancelledStylesCount) || Boolean(smartOrdersQuantity)
                                        }
                                        dataTest={DATATEST.NAV.ORDERS}
                                    >
                                        {canAccessToReplenishementRecommendation && (
                                            <MenuItem
                                                key="replenishment-recommendations"
                                                label={t("Replenishment Recommendations")}
                                                to={this.createBrandLink("/replenishment-recommendations")}
                                                viewport={viewport}
                                                addNewBadge={Boolean(smartOrdersQuantity)}
                                                badge={smartOrdersQuantity}
                                                dataTest={DATATEST.NAV.SMART_ORDERS_PAGE}
                                            />
                                        )}
                                        {cancelledStyles && [
                                            <MenuItem
                                                key="cancelled-styles"
                                                label={t("Cancelled Styles")}
                                                to={this.createBrandLink("/cancelled-styles")}
                                                viewport={viewport}
                                                addNewBadge={!!cancelledStylesCount}
                                                badge={cancelledStylesCount > 49 ? "49+" : cancelledStylesCount}
                                                dataTest={DATATEST.NAV.ORDERS_CANCELLED_STYLES}
                                            />,
                                        ]}
                                    </MenuItem>
                                )}

                            {me.account_type === "buyer" &&
                                hasActivePaymentAccount(scope) &&
                                flags.paymentsInvoicesMenuItemNu63696 && (
                                    <MenuItem
                                        Icon={MoneyIcon}
                                        label={t("Invoices")}
                                        to={this.createBrandLink("/invoices")}
                                        matches={paymentsMatches}
                                        location={location}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.INVOICES_MENU_ITEM}
                                    />
                                )}

                            {((!flags.paymentsInvoicesMenuItemNu63696 && this.hasLightspeedPaymentsProcessor()) ||
                                (flags.paymentsInvoicesMenuItemNu63696 && hasActivePaymentAccount(scope))) &&
                                this.restrictByModule("wholesale", true) &&
                                me.account_type === "brand" && (
                                    <MenuItem
                                        Icon={MoneyIcon}
                                        label={t("Payments")}
                                        to={this.createBrandLink(
                                            flags.paymentsInvoicesMenuItemNu63696 ? "/invoices" : "/lightspeed-reports"
                                        )}
                                        matches={paymentsMatches}
                                        location={location}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.PAYMENTS_MANAGEMENT}
                                    >
                                        {flags.paymentsInvoicesMenuItemNu63696 && (
                                            <MenuItem
                                                key="invoices"
                                                label={t("Invoices")}
                                                to={this.createBrandLink("/invoices")}
                                                viewport={viewport}
                                                datatest={DATATEST.NAV.INVOICES_MENU_ITEM}
                                            />
                                        )}
                                        {this.hasLightspeedPaymentsProcessor() && (
                                            <MenuItem
                                                key="transactions-and-deposits"
                                                label={t("Transactions and Deposits")}
                                                to={this.createBrandLink("/lightspeed-reports")}
                                                viewport={viewport}
                                                datatest={DATATEST.NAV.PAYMENTS_MANAGEMENT}
                                            />
                                        )}
                                        {me.hasPermission("modify_payment_account") && (
                                            <MenuItem
                                                key="payment-history"
                                                label={t("Payment History")}
                                                to={this.createBrandLink("/admin/brand/vp/paymenthistory")}
                                                viewport={viewport}
                                                datatest={DATATEST.NAV.DAILY_TRANSACTIONS}
                                            />
                                        )}
                                    </MenuItem>
                                )}

                            {this.restrictByModule("wholesale", true) &&
                                this.restrictByAccountType("brand") &&
                                me.hasPermission("view_campaigns") && (
                                    <MenuItem
                                        Icon={CampaignsIcon}
                                        label={Globalize.formatMessage("Campaigns")}
                                        to={this.createBrandLink("/campaigns")}
                                        viewport={viewport}
                                        location={location}
                                        matches={[
                                            pathToRegexp("/brand/:brand/campaign*"),
                                            pathToRegexp("/brand/:brand/contact-group*"),
                                            pathToRegexp("/brand/:brand/smart-group*"),
                                            pathToRegexp("/brand/:brand/static-group*"),
                                        ]}
                                        dataTest={DATATEST.NAV.CAMPAIGNS}
                                    >
                                        <MenuItem
                                            label={Globalize.formatMessage("View Campaigns")}
                                            to={this.createBrandLink("/campaigns")}
                                            viewport={viewport}
                                            dataTest={DATATEST.NAV.VIEW_CAMPAIGNS}
                                        />
                                        <MenuItem
                                            label={Globalize.formatMessage("View Contact Groups")}
                                            to={this.createBrandLink("/contact-groups")}
                                            viewport={viewport}
                                            dataTest={DATATEST.NAV.CONTACT_GROUPS}
                                        />
                                        <MenuItem
                                            label={Globalize.formatMessage("Create a Smart Group")}
                                            to={this.createBrandLink("/smart-group")}
                                            viewport={viewport}
                                            dataTest={DATATEST.NAV.SMART_GROUPS}
                                        />
                                        <MenuItem
                                            label={Globalize.formatMessage("Create a Fixed Group")}
                                            to={this.createBrandLink("/static-group")}
                                            viewport={viewport}
                                            dataTest={DATATEST.NAV.STATIC_GROUPS}
                                        />
                                    </MenuItem>
                                )}
                            {this.restrictByModule("wholesale", true) &&
                                this.hasAccessBySubscription(STANDARD) &&
                                scope.brand._hasActiveGalleries &&
                                !me.isGuestBuyer() && (
                                    <MenuItem
                                        Icon={MediaIcon}
                                        label={Globalize.formatMessage("Media")}
                                        to={this.createBrandLink("/media")}
                                        location={location}
                                        matches={pathToRegexp("/brand/:brand/media")}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.MEDIA}
                                    />
                                )}
                            {this.restrictByModule("reporting", true) && (
                                <MenuItem
                                    Icon={ReportingIcon}
                                    label={Globalize.formatMessage("Reporting")}
                                    to={this.createBrandLink("/reporting")}
                                    location={location}
                                    matches={pathToRegexp("/brand/:brand/reporting")}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.REPORTING}
                                />
                            )}
                            {me.account_type === "nuorder" && (
                                <MenuItem
                                    Icon={HandShake}
                                    label={Globalize.formatMessage("Marketplace")}
                                    to={toMarketplace}
                                    viewport={viewport}
                                    location={location}
                                    matches={pathToRegexp(toMarketplace)}
                                    dataTest={DATATEST.NAV.MARKETPLACES}
                                >
                                    <MenuItem
                                        label={Globalize.formatMessage("NuORDER Marketplace")}
                                        to={toMarketplace}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.ONLINE_TRADESHOW}
                                    />
                                    <MenuItem
                                        label={Globalize.formatMessage("Find New Accounts")}
                                        to="/marketplace"
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.FIND_NEW_ACCOUNTS}
                                        onClick={this.handleFindNewAccountsMenuClick}
                                    />
                                </MenuItem>
                            )}
                            {me.account_type === "buyer" && (
                                <MenuItem
                                    Icon={HandShake}
                                    label={Globalize.formatMessage("NuORDER Marketplace")}
                                    to={toMarketplace}
                                    location={location}
                                    matches={pathToRegexp(toMarketplace)}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.ONLINE_TRADESHOW}
                                />
                            )}
                            {me.account_type !== "nuorder" &&
                                this.restrictByModule("marketplace") &&
                                this.hasAccessBySubscription(STANDARD) && (
                                    <MenuItem
                                        Icon={HandShake}
                                        label={Globalize.formatMessage("Find New Accounts")}
                                        to="/marketplace"
                                        location={location}
                                        matches={pathToRegexp("/marketplace")}
                                        viewport={viewport}
                                        onClick={this.handleFindNewAccountsMenuClick}
                                        dataTest={DATATEST.NAV.FIND_NEW_ACCOUNTS}
                                    />
                                )}
                            {canAccessLiveEvents && <Sites viewport={viewport} isOpen={isOpen || isPinned} />}
                            {me.account_type === "nuorder" && (
                                <MenuItem
                                    Icon={SettingsIcon}
                                    label={Globalize.formatMessage("Settings")}
                                    to={
                                        scope.brand && scope.brand._id
                                            ? this.createBrandLink("/admin/brand")
                                            : "/management/utilities"
                                    }
                                    viewport={viewport}
                                    location={location}
                                    matches={[
                                        pathToRegexp("/brand/:brand/admin"),
                                        pathToRegexp("/brand/:brand/management"),
                                        pathToRegexp("/management"),
                                    ]}
                                    dataTest={DATATEST.NAV.SETTINGS}
                                >
                                    <MenuItem
                                        label={Globalize.formatMessage("Brand Admin")}
                                        to={this.createBrandLink("/admin/brand")}
                                        hasAccess={this.restrictByModule("admin", true)}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.ADMIN}
                                    />
                                    <MenuItem
                                        label={Globalize.formatMessage("Brand Management")}
                                        to={this.createBrandLink("/management/nuorder")}
                                        hasAccess={this.restrictByModule("management", true)}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.BRAND_MANAGEMENT}
                                    />
                                    <MenuItem
                                        label={Globalize.formatMessage("NuORDER Utilities")}
                                        to={"/management/utilities"}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.UTILITIES}
                                    />
                                    <MenuItem
                                        label={Globalize.formatMessage("Retailer Settings")}
                                        to="/the-wall/settings"
                                        hasAccess={this.restrictByModule("manage")}
                                        location={location}
                                        matches={pathToRegexp("/the-wall/settings")}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.RETAILER_SETTINGS}
                                    />
                                    {scope.brand && scope.brand._id && (
                                        <MenuItem
                                            label={Globalize.formatMessage("Pages Manager")}
                                            to={this.createBrandLink("/pages")}
                                            dataTest={DATATEST.NAV.PAGES_MANAGER}
                                        />
                                    )}
                                    <MenuItem
                                        label={Globalize.formatMessage("Sites Manager")}
                                        to={this.createBrandLink("/sites")}
                                        location={location}
                                        matches={[pathToRegexp("/sites"), pathToRegexp("/brand/:brand/sites")]}
                                        viewport={viewport}
                                    />
                                </MenuItem>
                            )}
                            {me.account_type !== "nuorder" && this.restrictByModule("admin", true) && (
                                <MenuItem
                                    Icon={SettingsIcon}
                                    label={Globalize.formatMessage("Settings")}
                                    to={this.createBrandLink("/admin/brand")}
                                    hasAccess={this.restrictByModule("admin", true)}
                                    location={location}
                                    matches={pathToRegexp("/brand/:brand/admin")}
                                    viewport={viewport}
                                    dataTest={DATATEST.NAV.SETTINGS}
                                >
                                    <MenuItem
                                        label={Globalize.formatMessage("Brand Admin")}
                                        to={this.createBrandLink("/admin/brand")}
                                        hasAccess={this.restrictByModule("admin")}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.ADMIN}
                                    />
                                    <MenuItem
                                        label={Globalize.formatMessage("Pages Manager")}
                                        to={this.createBrandLink("/pages")}
                                        hasAccess={
                                            !!scope.brand.settings.enable_pages_manager &&
                                            me.hasPermission("update_brand")
                                        }
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.PAGES_MANAGER}
                                    />
                                    {me.hasPermission("manage_site_pages") && (
                                        <MenuItem
                                            label={Globalize.formatMessage("Sites Manager")}
                                            addNewBadge={true}
                                            badge={Globalize.formatMessage("New")}
                                            to={this.createBrandLink("/sites")}
                                            location={location}
                                            matches={[pathToRegexp("/sites"), pathToRegexp("/brand/:brand/sites")]}
                                            viewport={viewport}
                                        />
                                    )}
                                </MenuItem>
                            )}
                            {me.account_type !== "nuorder" &&
                                !me.isGuestBuyer() &&
                                !this.restrictByModule("admin", true) &&
                                me.hasPermission("manage_site_pages") && (
                                    <MenuItem
                                        Icon={SettingsIcon}
                                        label={Globalize.formatMessage("Sites Manager")}
                                        to={this.createBrandLink("/sites")}
                                        location={location}
                                        matches={[pathToRegexp("/sites"), pathToRegexp("/brand/:brand/sites")]}
                                        viewport={viewport}
                                        dataTest={DATATEST.NAV.SITES_MANAGER}
                                    />
                                )}
                            {this.restrictByAccountType("brand") && this.restrictByDevice("iPad") && (
                                <MenuItem
                                    Icon={DownloadIcon}
                                    label={Globalize.formatMessage("Download App")}
                                    to={`//${window.location.host.replace("app.", "wholesale.")}/ipad/install/verify`}
                                    viewport={viewport}
                                />
                            )}
                            {me.account_type === "buyer" &&
                                (this.restrictByModule("manage") ||
                                    canAccessSiteSettings ||
                                    canAccessPOSIntegration ||
                                    canAccessMerchantManagement) && (
                                    <MenuItem
                                        Icon={SettingsIcon}
                                        label={Globalize.formatMessage("Settings")}
                                        to={this.getOrganizationSettings("general").organizationSettingsURL}
                                        location={location}
                                        matches={
                                            canAccessSiteSettings
                                                ? [pathToRegexp("/sites"), pathToRegexp("/brand/:brand/sites")]
                                                : pathToRegexp(
                                                      this.getOrganizationSettings("general")
                                                          .organizationSettingsMatchesURL
                                                  )
                                        }
                                        viewport={viewport}
                                        dataTest={
                                            canAccessSiteSettings ? DATATEST.NAV.SITES_MANAGER : DATATEST.NAV.THE_WALL
                                        }
                                    >
                                        {this.restrictByModule("manage") && (
                                            <MenuItem
                                                label={Globalize.formatMessage("Manage Store Profile")}
                                                to={
                                                    this.getOrganizationSettings("store-profile")
                                                        .organizationSettingsURL
                                                }
                                                location={location}
                                                matches={pathToRegexp(
                                                    this.getOrganizationSettings("store-profile")
                                                        .organizationSettingsMatchesURL
                                                )}
                                                viewport={viewport}
                                                dataTest={DATATEST.NAV.THE_WALL}
                                            />
                                        )}
                                        {canAccessPOSIntegration && (
                                            <MenuItem
                                                label={Globalize.formatMessage("Lightspeed Retail")}
                                                to="/the-wall/settings/b2b"
                                                location={location}
                                                matches={pathToRegexp("/the-wall/settings/b2b")}
                                                viewport={viewport}
                                                dataTest={DATATEST.NAV.B2B_LIGHTSPEED_RETAIL}
                                            />
                                        )}
                                        {canAccessMerchantManagement && (
                                            <MenuItem
                                                label={Globalize.formatMessage("Manage Merchant Members")}
                                                to="/the-wall/settings/b2b/manage-merchants"
                                                location={location}
                                                matches={pathToRegexp("/the-wall/settings/b2b/manage-merchants")}
                                                viewport={viewport}
                                                dataTest={DATATEST.NAV.B2B_LIGHTSPEED_RETAIL}
                                            />
                                        )}

                                        {canAccessSiteSettings && (
                                            <MenuItem
                                                label={Globalize.formatMessage("Sites Manager")}
                                                to={this.createBrandLink("/sites")}
                                                location={location}
                                                matches={[pathToRegexp("/sites"), pathToRegexp("/brand/:brand/sites")]}
                                                viewport={viewport}
                                                dataTest={DATATEST.NAV.SITES_MANAGER}
                                            />
                                        )}
                                    </MenuItem>
                                )}
                        </Section>
                        <Profile
                            me={me}
                            viewport={viewport}
                            to={scope.brand && scope.brand._id ? this.createBrandLink("/profile") : "/profile"}
                        >
                            <MenuItem
                                label={Globalize.formatMessage("Edit Profile")}
                                to={scope.brand && scope.brand._id ? this.createBrandLink("/profile") : "/profile"}
                                dataTest={DATATEST.NAV.EDIT_PROFILE}
                            />
                            {me.actual_user && me.actual_user.email && (
                                <MenuItem
                                    to={
                                        scope.brand && scope.brand._id
                                            ? this.createBrandLink("/stop-impersonation")
                                            : "/stop-impersonation"
                                    }
                                    dataTest={DATATEST.NAV.STOP_IMPERSONATION}
                                    label={Globalize.formatMessage("Stop Impersonation")}
                                />
                            )}
                            {me.account_type !== "nuorder" && !me.actual_user && (
                                <MenuItem
                                    label={Globalize.formatMessage("Request Impersonation")}
                                    dataTest={DATATEST.NAV.REQUEST_IMPERSONATION}
                                    to={
                                        scope.brand && scope.brand._id
                                            ? this.createBrandLink("/request-impersonation")
                                            : "/request-impersonation"
                                    }
                                />
                            )}
                            {me.account_type === "nuorder" && !me.actual_user && (
                                <MenuItem
                                    label={Globalize.formatMessage("Impersonation")}
                                    dataTest={DATATEST.NAV.ENTER_IMPERSONATION}
                                    to={
                                        scope.brand && scope.brand._id
                                            ? this.createBrandLink("/enter-impersonation")
                                            : "/enter-impersonation"
                                    }
                                />
                            )}
                            {me.account_type === "buyer" && scope.brand && scope.brand._id && (
                                <MenuItem
                                    label={Globalize.formatMessage("Manage Payment Methods")}
                                    to={this.createBrandLink("/payment-methods")}
                                    onClick={this.handleManageCreditCardsMenuClick}
                                    dataTest={DATATEST.NAV.MANAGE_CREDIT_CARDS}
                                />
                            )}
                            <MenuItem
                                label={Globalize.formatMessage("Logout")}
                                onClick={this.handleLogout}
                                dataTest={DATATEST.NAV.LOG_OUT}
                            />
                        </Profile>
                        <Footer
                            isPinned={isPinned}
                            touchDevice={touchDevice}
                            onTogglePin={this.handleToggleMenu}
                            isMobile={isMobile}
                        />
                    </nav>
                </ReactTouchEvents>
            </div>
        );
    }

    /**
     * Check availability by brand subscription.
     * @param {IBrandSubscription} subscription - subscription type check availability for
     * @return {boolean} returns true if the brand subscription includes the input one.
     */
    hasAccessBySubscription(subscription = STANDARD) {
        const { scope } = this.props;
        return scope.brand && scope.brand._id && scope.brand.checkSubscription(subscription);
    }
}

export default Timeout(SiteNav);
